// src/utils/element-locale.js
import ElementLocale from 'element-ui/lib/locale'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import elementEn from 'element-ui/lib/locale/lang/en'

const SUPPORTED = ['zh', 'en']
const FALLBACK_LANG = 'en'
const LANG_KEY = 'app_lang'

// 本文件不负责"解析初始语言"。
// 初始语言由 i18n/index.js 的 resolveInitialLang() 统一解析，
// 再通过 createI18n(lang) -> applyElementLocale(lang) 同步过来。
// 这里的 getFallbackLang 仅在 applyElementLocale() 未显式传参时兜底，
// 优先级与 i18n/index.js 保持一致（i18n 实例 > localStorage > 浏览器 > en）。

function getFallbackLang() {
  // 1. 已创建的 i18n 实例（最准确）
  try {
    const mod = require('../i18n')
    const i18n = mod && mod.getI18n && mod.getI18n()
    if (i18n && SUPPORTED.indexOf(i18n.locale) !== -1) return i18n.locale
  } catch (e) { }

  // 2. localStorage（用户显式切换）
  try {
    const saved = localStorage.getItem(LANG_KEY)
    if (saved && SUPPORTED.indexOf(saved) !== -1) return saved
  } catch (e) { }

  // 3. 浏览器语言
  const nav = (navigator.language || navigator.userLanguage || '').toLowerCase()
  if (nav.indexOf('zh') === 0) return 'zh'
  if (nav.indexOf('en') === 0) return 'en'

  // 4. 兜底
  return FALLBACK_LANG
}

/**
 * 同步 Element-UI 内建文案语言。
 * @param {string} [lang] 目标语言；不传则从 i18n 实例 / localStorage / 浏览器推断。
 * @returns {string} 实际生效的语言
 */
export function applyElementLocale(lang) {
  let l = lang
  if (!l || SUPPORTED.indexOf(l) === -1) {
    l = getFallbackLang()
  }
  ElementLocale.use(l === 'zh' ? elementZh : elementEn)
  return l
}

// 不在模块顶层调用 applyElementLocale()：
// 初始语言统一由 main.js -> createI18n(lang) -> applyElementLocale(lang) 触发，
// 避免模块加载时提前用错误语言覆盖。



// WEBPACK FOOTER //
// ./src/utils/element-locale.js